import { Bell } from "lucide-react";
import { formatReminders } from "../utils/reminderFormat";
import { hasReminderSetting, remindersAreOn } from "../utils/itemReminderToggle";

// Detail-panel row for a task/event's reminders with an on/off switch. Hidden
// when the item never had a reminder. See utils/itemReminderToggle.js.
export function ReminderToggleRow({ item, onToggle }) {
  if (!hasReminderSetting(item)) return null;
  const on = remindersAreOn(item);
  const label = formatReminders(on ? item.reminders : item.remindersOff) || "Reminder";
  return (
    <div onClick={() => onToggle(!on)} role="switch" aria-checked={on} aria-label="Reminders on/off"
      style={{ display: "flex", alignItems: "center", gap: 9, fontSize: 13, color: on ? "var(--c-text-mid)" : "var(--c-text-soft)", fontWeight: 600, cursor: "pointer" }}>
      <span style={{ flexShrink: 0, color: "var(--c-text-soft)", display: "inline-flex" }}><Bell size={14} /></span>
      <span style={{ flex: 1, wordBreak: "break-word", lineHeight: 1.4, textDecoration: on ? "none" : "line-through" }}>{label}{on ? "" : " · off"}</span>
      <div style={{ width: 38, height: 22, borderRadius: 999, background: on ? "linear-gradient(135deg, var(--c-primary-light), var(--c-primary-deep))" : "var(--c-border)", position: "relative", flexShrink: 0, transition: "background 0.2s" }}>
        <div style={{ position: "absolute", top: 2, left: on ? 18 : 2, width: 18, height: 18, borderRadius: "50%", background: "var(--c-bg-card)", boxShadow: "0 1px 3px rgba(0,0,0,0.2)", transition: "left 0.2s cubic-bezier(0.34,1.56,0.64,1)" }} />
      </div>
    </div>
  );
}
